module.exports = __webpack_public_path__ + "static/media/gallery_ng.b1f8b2d9.png";